import { useMediaQuery as p } from "@react-hookz/web";
import { u as m } from "./window-CRKligjd.mjs";
import { t as o } from "./breakpoints-DvaoDEis.mjs";
import { r as d } from "./index-CnymUPx7.mjs";
const i = (e, t) => p(d(e), t), h = (e, t = !1, a) => {
  const s = i(e, {
    initializeWithValue: !1,
    ...a
  });
  return s ?? t;
}, y = () => {
  var e;
  const t = i(o.breakpoints.up("largeDesktop"), {
    initializeWithValue: !1
  }), a = i(o.breakpoints.only("mediumDesktop"), {
    initializeWithValue: !1
  }), s = i(o.breakpoints.between("desktop", "mediumDesktop"), {
    initializeWithValue: !1
  }), n = i(o.breakpoints.only("tablet"), {
    initializeWithValue: !1
  }), r = i(o.breakpoints.only("mobile"), {
    initializeWithValue: !1
  });
  if (m()) return "mobile";
  const l = {
    desktop: s,
    largeDesktopUp: t,
    mediumDesktop: a,
    mobile: r,
    tablet: n
  };
  return (e = Object.keys(l).find((u) => l[u])) !== null && e !== void 0 ? e : "mobile";
};
export {
  y as a,
  h as u
};
//# sourceMappingURL=hooks-DEKsUlYx.mjs.map
